module.exports = __webpack_public_path__ + "assets/images/predio_04a394e26fbd5b07da7c07fe3da0c281.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/yellow/paralelepipedo/predio.png
// module id = 209
// module chunks = 0